// frontend/src/pages/NewsDetailPage/NewsDetailPage.jsx (обновленный)
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs';
import './NewsDetailPage.css';
import clockIcon from '../../assets/icons/gray_clock.svg';
import { newsService } from '../../services/newsService';

const NewsDetailPage = () => {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchNewsDetail = async () => {
      try {
        setIsLoading(true);
        const data = await newsService.getNewsById(id);
        setNewsItem(data.news);
      } catch (error) {
        console.error('Ошибка загрузки новости:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNewsDetail();
  }, [id]);

  const breadcrumbsItems = [
    { path: '/', label: 'Главная' },
    { path: '/news', label: 'Новости' },
    { path: `/news/${id}`, label: newsItem?.title || 'Новость' }
  ];

  if (isLoading) {
    return (
      <div className="news-detail-page">
        <Header />
        <main className="news-detail-content">
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (!newsItem) {
    return (
      <div className="news-detail-page">
        <Header />
        <main className="news-detail-content">
          <div className="error-container">
            <h2 className="error-title">Новость не найдена</h2>
            <p className="error-text">Запрошенная новость не существует или была удалена</p>
            <Link to="/news" className="back-button">
              <button className="back-to-news-btn">
                <span>Вернуться к новостям</span>
              </button>
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).replace(/\//g, '.');
  };

  return (
    <div className="news-detail-page">
      <Header />
      
      <main className="news-detail-content">
        <div className="news-detail-top-section">
          <Breadcrumbs items={breadcrumbsItems} />
        </div>
        <div className="news-detail-container">
          <article className="news-detail-article">
            
            <h1 className="news-detail-title">{newsItem.title}</h1>
            
            <div className="news-detail-description">
              {(newsItem.fullDescription || newsItem.description).split('\n').map((paragraph, index) => {
                const trimmed = paragraph.trim();
                
                if (trimmed.startsWith('•') || trimmed.startsWith('-')) {
                  return (
                    <div key={index} className="news-detail-list-wrapper">
                      <ul className="news-detail-list">
                        <li className="news-detail-list-item">
                          {trimmed.substring(1).trim()}
                        </li>
                      </ul>
                    </div>
                  );
                }
                
                if (trimmed === '') {
                  return <div key={index} className="news-detail-empty-line"></div>;
                }
                
                return (
                  <p key={index} className="news-detail-paragraph">
                    {paragraph}
                  </p>
                );
              })}
            </div>
            
            <div className="news-detail-image-container">
              <img
                src={newsItem.image}
                alt={newsItem.title}
                className="news-detail-image"
              />
            </div>
            
            <div className="news-detail-date-section">
              <div className="news-detail-date-wrapper">
                <img
                  src={clockIcon}
                  alt="Дата публикации"
                  className="news-detail-clock"
                />
                <span className="news-detail-date">{formatDate(newsItem.date)}</span>
              </div>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NewsDetailPage;